/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@coursera/cds-core';
import { ArrowPreviousIcon } from '@coursera/cds-icons';

import _t from 'i18n!nls/reviews';

type Props = {
  courseName: string;
  href: string;
};

const styles = {
  backButton: css`
    margin-top: var(--cds-spacing-300);
    max-width: none;
  `,
};

const ReviewsBackButton = ({ courseName, href }: Props) => {
  return (
    <Button
      component="a"
      css={styles.backButton}
      edgeAlign="start"
      href={href}
      icon={<ArrowPreviousIcon />}
      iconPosition="before"
      size="small"
      variant="ghost"
    >
      <FormattedMessage message={_t('Back to {courseName}')} courseName={courseName} />
    </Button>
  );
};

export default ReviewsBackButton;
